import * as React from 'react'
import theme from '../theme'

interface Props {
  colour?: string
}

const InvitationIcon = (props: Props): JSX.Element => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='84'
      height='84'
      viewBox='0 0 84 84'
    >
      <title>Invitation</title>
      <path
        fill={props.colour ? props.colour : theme.colours.white}
        fillRule='evenodd'
        d='M79.86 17.5h.03l.068.003.018.002-.116-.005c.835 0 1.515.686 1.515 1.53v45.938c0 .8-.606 1.455-1.377 1.526l-.138.006H4.14c-.837 0-1.515-.686-1.515-1.532V19.03c0-.763.554-1.396 1.278-1.511v.001l.028-.004c.03-.006.06-.009.091-.011l.064-.003c.018-.002.036-.002.054-.002h75.72zm-1.515 4.9l-35.4 29.752c-.236.2-.516.313-.802.34L42 52.5c-.336 0-.67-.116-.947-.348L5.653 22.4v41.037h72.692V22.4zm-2.66-1.838H8.312L42 48.872l33.685-28.31z'
      />
    </svg>
  )
}

export default InvitationIcon
